import store from '../../../store/store';
import { asyncHandler } from '../async-handler';
import { RequestInfo } from '../../../interfaces/RequestInfo';
import { ACTION_RULE_URL } from './action-api-urls';

export interface DeleteActionRuleResponse {
  success: boolean;
  message: string | null;
  data: null;
}

export default async function delete_action_rule_api_call(
  ruleId: string
): Promise<boolean> {
  try {
    const shopSlug = store.getState().user?.company?.shop_slug;
    const accessToken = store.getState().auth.authorization.accessToken;
    const sellerToken = accessToken?.sellerToken;

    const requestInfo: RequestInfo = {
      url: ACTION_RULE_URL(shopSlug, ruleId),
      method: 'DELETE',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: accessToken.type + ' ' + sellerToken,
      },
    };

    const actionType = 'DELETE_ACTION_RULE';
    const customMsg = 'Action rule deleted successfully.';

    const res: any = await asyncHandler(
      requestInfo,
      actionType,
      customMsg,
      true,
      false
    );

    const response: DeleteActionRuleResponse = res?.data;

    if (res?.actionType === actionType && response?.success === true) {
      return true;
    } else {
      return false;
    }
  } catch (exception) {
    console.log('Error during delete action rule request');
    return false;
  }
}
